import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { AreaValidations } from '../../../../models';
import styles from './AreaGeoForm.styles';

import {
  LOCATION_TYPES,
  GEO_REFERENCE_TYPES
} from '../../../../constants/areas';
import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import MapGLInput from '../../../inputs/mapglinput/MapGLInput';

export class AreaGeoForm extends Component {
  componentDidMount() {
    if (!this.props.isOutdoor && !this.props.isGeoReferenced) {
      this.props.continue();
    }
  }
  render() {
    if (!this.props.isOutdoor && !this.props.isGeoReferenced) {
      return false;
    }
    return (
      <AddForm onSubmit={this.props.handleSubmit} styles={styles.form}>
        <Field
          name="polygon"
          type="polygon"
          validate={AreaValidations.polygon}
          component={MapGLInput}
          props={{
            showMap: true
          }}
        />
        <FormActions>
          <Button>{I18n.t('add.set')}</Button>
        </FormActions>
      </AddForm>
    );
  }
}

const selector = formValueSelector('addarea');
const mapStateToProps = state => {
  const { location, geoReferenced } = selector(
    state,
    'location',
    'geoReferenced'
  );
  return {
    isOutdoor: LOCATION_TYPES.OUTDOOR === location,
    isGeoReferenced: GEO_REFERENCE_TYPES.YES === geoReferenced
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addarea',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(AreaGeoForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/addareaform/areageoform/AreaGeoForm.js